export default {
  url_get_audio: "https://customers-server.bestcall.ro/",
  url_customer: "https://customers-server.bestcall.ro/",
  // url_customer: "http://localhost:3001/",
};
